import * as React from "react";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { Button } from "../../../../components/ui/button";
import { Trash2, Plus, Pencil } from "lucide-react";
import { CommodityDialog } from "./CommodityDialog";
import { commodityOptions } from "data";
import { FieldError } from "../FieldError";

export function CargoList() {
  const { control, getValues, setValue } = useFormContext();
  const { fields, append, remove, update } = useFieldArray({ 
    control, 
    name: "step8.commodity_array" 
  });

  const c8 = useWatch({ control, name: "step8.carrier" });

  const [open, setOpen] = React.useState(false);
  const [editingIndex, setEditingIndex] = React.useState(null);

  const handleEdit = (idx) => {
    setEditingIndex(idx);
    setOpen(true);
  };

  const handleSave = (item) => {
    if (editingIndex !== null) {
      update(editingIndex, item); // replaces the commodity at index
      setEditingIndex(null);
    } else {
      append(item);
    }
  };

  return (
    <section className="rounded-xl space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-xl font-semibold">Cargo</h3>
        <Button 
          className="bg-red-600 hover:bg-red-700 text-white" 
          onClick={() => {
            setEditingIndex(null);
            setOpen(true);
          }}
        >
          <Plus className="h-4 w-4 mr-2" /> Add Commodity
        </Button>
      </div>

      {fields.length === 0 ? (
        <p className="text-sm text-gray-600">
          No commodities added. Please click add commodity to get started.
        </p>
      ) : (
        <div className="space-y-2">
          {fields.map((c, idx) => (
            <div 
              key={c.id} 
              className="flex items-center justify-between rounded-md border p-3"
            >
              <div className="text-sm">
                <div className="font-medium">
                  {commodityOptions.find((co) => co.value === c.commodityKey)?.label }
                </div>
                <div className="text-gray-500">{c.commodityPercentage}% of loads</div>
              </div>
              <div className="flex gap-1">
                <Button 
                  variant="ghost" 
                  size="icon" 
                  onClick={() => handleEdit(idx)} 
                  aria-label="Edit commodity"
                >
                  <Pencil className="h-4 w-4" />
                </Button>
                <Button 
                  variant="ghost" 
                  size="icon" 
                  onClick={() => remove(idx)} 
                  aria-label="Remove commodity"
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            </div>
          ))}
          <FieldError name={"step8.commodity_array"} step={"step8"} />
        </div>
      )}

      <CommodityDialog
        carriers={c8}
        open={open}
        onOpenChange={(o) => {
          setOpen(o);
          if (!o) setEditingIndex(null);
        }}
        onAdd={handleSave}
        updateCarriers={() => {
          // Remove Cover Whale from step1.carrier
          const currentCarriers = getValues("step1.carrier") || [];

          const updatedCarriers = currentCarriers.filter((carrier) => carrier !== "Cover Whale");

          setValue("step1.carrier", updatedCarriers);
        }}
        defaultValues={editingIndex !== null ? fields[editingIndex] : undefined}
      />
    </section>
  );
}
